import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { ResearchHkbkRoutingModule } from './research-hkbk-routing.module';
import { ResearchHkbkListComponent } from './research-hkbk-list/research-hkbk-list.component';
import { ResearchHkbkCreateComponent } from './research-hkbk-create/research-hkbk-create.component';

@NgModule({
  declarations: [ResearchHkbkListComponent, ResearchHkbkCreateComponent],
  imports: [
    CommonModule,
    ResearchHkbkRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class ResearchHkbkModule { }
